import PocketBase from 'pocketbase';

const PB_URL = process.env.REACT_APP_POCKETBASE_URL || window.location.origin || 'https://housedesigns99.com';

const pb = new PocketBase(PB_URL);
pb.autoCancellation(false);

const stored = localStorage.getItem('pb_auth');
if (stored) {
  try {
    const { token, model } = JSON.parse(stored);
    if (token && model) pb.authStore.save(token, model);
  } catch (_) {}
}

pb.authStore.onChange((token, model) => {
  if (token && model) {
    localStorage.setItem('pb_auth', JSON.stringify({ token, model }));
  } else {
    localStorage.removeItem('pb_auth');
  }
});

export default pb;
export { pb };

export const getImageUrl = (item, imageName) => {
  if (!item || !imageName) return null;
  const fileName = Array.isArray(imageName) ? imageName[0] : imageName;
  if (!fileName) return null;
  if (typeof pb.files?.getUrl === 'function') {
    return pb.files.getUrl(item, fileName);
  }
  const base = pb.baseUrl || PB_URL;
  return `${base}/api/files/${item.collectionId || item.collectionName}/${item.id}/${encodeURIComponent(fileName)}`;
};
